import _ from 'lodash';
import {
  ACTIVITY_MARK_AS_DONE,
  ADD_ACTIVITY, CREATE_PERSONS,
  DROP_PERSON, GET_ACTIVITIES_COMPLETED,
  GET_ACTIVITY, GET_ACTIVITY_NOTES,
  GET_ALL_POSSIBLE_PERSONS_LIST, GET_CONTACTED, GET_FOLLOW_UP, GET_PERSONS_CHANGELOG,
  GET_POSSIBLE_PERSONS_LIST,
  GET_SINGLE_POSSIBLE_PERSON, GET_TOTAL_CONTACTS_IMPORTED,
  OPEN_ACTIVITY_MODAL,
  RESET_ACTIVITY_DATA,
  UPDATE_ACTIVITY_DATA,
  UPDATE_SINGLE_POSSIBLE_PERSON,
} from '../actions/possiblePersons';
import { personStatusPosition } from '../../utils/data/data';
import accountHelpers from '../../utils/accountHelpers';

const initialState = {
  personsList: {},
  personsAllList: [],
  singlePerson: {},
  openActivity: false,
  activityData: [],
  allActivityData: [],
  modalActivityData: [],
  noteActivityData: [],
  activityCurrentPage: 1,
  activityPageCount: 1,
  noteCount: { Notes: '' },
  changelogData: [],
  changelogCurrentPage: 1,
  changelogPageCount: 1,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_POSSIBLE_PERSONS_LIST.SUCCESS: {
      return {
        ...state,
        personsList: payload.data.data,
      };
    }

    case DROP_PERSON.REQUEST: {
      return {
        ...state,
        personsList: payload.item.parent === payload.currentItem.parent
          ? state.personsList
          : {
            ...state.personsList,
            [payload.currentItem.parent]: {
              _meta: {
                ...state.personsList[payload.currentItem.parent]._meta,
                total: +state.personsList[payload.currentItem.parent]._meta.total - 1,
              },

              data: state.personsList[payload.currentItem.parent].data
                .filter((p) => p.id !== payload.currentItem.id),
            },

            [payload.item.parent]: {
              _meta: {
                ...state.personsList[payload.item.parent]._meta,
                total: +state.personsList[payload.item.parent]._meta.total + 1,
              },

              data: [
                state.personsList[payload.currentItem.parent].data.find((p) => p.id === payload.currentItem.id),
                ...state.personsList[payload.item.parent].data,
              ],
            },
          },
      };
    }

    case GET_POSSIBLE_PERSONS_LIST.SUCCESS: {
      return {
        ...state,
        personsList: {
          ...state.personsList,
          [payload.status]: {
            data: [...state.personsList[payload.status].data, ...payload.data.data],
            _meta: payload.data._meta,
          },

        },
      };
    }

    case GET_SINGLE_POSSIBLE_PERSON.SUCCESS: {
      return {
        ...state,
        singlePerson: payload.data.data,
        noteCount: { Notes: payload.data.data.notesCount },
      };
    }

    case UPDATE_SINGLE_POSSIBLE_PERSON.SUCCESS: {
      return {
        ...state,
        singlePerson: payload.data.patientList,
      };
    }

    case OPEN_ACTIVITY_MODAL: {
      return {
        ...state,
        openActivity: payload,
      };
    }

    case GET_ACTIVITY.SUCCESS: {
      return {
        ...state,
        [payload.path]: payload.data.data.notes.map((n) => ({
          ...n,
          createdAt: `${n.createdAt}.000Z`,
          start: `${n.start}.000Z`,
          end: `${n.end}.000Z`,
          updatedAt: `${n.updatedAt}.000Z`,
        })),

        activityCurrentPage: payload.path === 'allActivityData'
          ? payload.data.data._meta.currentPage
          : state.activityCurrentPage,

        activityPageCount: payload.path === 'allActivityData'
          ? payload.data.data._meta.pageCount
          : state.activityPageCount,
      };
    }

    case UPDATE_ACTIVITY_DATA.SUCCESS: {
      return {
        ...state,
        activityData: state.activityData.map((d) => (d.id === payload.data.id
          ? { ...d, ...payload.data, updatedAt: new Date().toISOString() }
          : d)),
        allActivityData: state.allActivityData.map((d) => (d.id === payload.data.id
          ? { ...d, ...payload.data, updatedAt: new Date().toISOString() }
          : d)),
      };
    }

    case ACTIVITY_MARK_AS_DONE.REQUEST: {
      return {
        ...state,
        openActivity: { ...state.openActivity, status: payload.status },
        activityData: state.activityData.map((d) => (d.id === payload.id
          ? { ...d, ...payload.data, status: payload.status }
          : d)),
      };
    }

    case GET_ACTIVITY_NOTES.SUCCESS: {
      return {
        ...state,
        noteActivityData: payload.data.notes,
      };
    }

    case RESET_ACTIVITY_DATA: {
      return {
        ...state,
        [payload]: [],
      };
    }

    case ADD_ACTIVITY.SUCCESS: {
      const { createdAt } = payload.data.data.note;
      const activityType = payload.data.data.note.type;
      return {
        ...state,
        [payload.path]: [payload.data.data.note, ...state[payload.path]],
        noteCount: {
          Notes: payload.path === 'noteActivityData'
            ? +state.noteCount.Notes + 1
            : state.noteCount.Notes,
        },
        allActivityData: [{
          ...payload.data.data.note,
          creator: { name: accountHelpers.getUser().name },
        }, ...state.allActivityData],

        changelogData: [{
          id: new Date(),
          type: `create${activityType}`,
          description: ` added ${activityType}`,
          updatedAt: createdAt,
          creator: { name: accountHelpers.getUser().name },
        },
        ...state.changelogData],
      };
    }

    case CREATE_PERSONS.SUCCESS: {
      const status = _.findKey(personStatusPosition, (o) => o === payload.status);

      return {
        ...state,
        personsList: {
          ...state.personsList,
          [status]: {
            ...state.personsList[status],
            data: [payload, ...state.personsList[status].data],
          },
        },
      };
    }

    case GET_PERSONS_CHANGELOG.SUCCESS: {
      return {
        ...state,
        changelogData: payload.data.logs,
        changelogCurrentPage: payload.data._meta.currentPage,
        changelogPageCount: payload.data._meta.pageCount,
      };
    }

    default:
      return state;
  }
};

export default reducer;
